import React from 'react';
import { useIntl } from 'react-intl';

import { useStateFromProp } from '~hooks/common';

import Modal from '~components/modal';

const MinimumRateModal = ({ isOpened, onToggle = () => {} }) => {
  const intl = useIntl();
  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={() => setModalOpen()} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {intl.formatMessage({
            id: `containers.operations.form.fields.minimum-rate.modal.headline`,
            defaultMessage: 'About rates',
          })}
        </h2>
        <p>
          {intl.formatMessage({
            id: `containers.operations.form.fields.minimum-rate.modal.description`,
            defaultMessage:
              'The standard rate is €11.85. We advise you to stay in line with the standard rate. We suggest not to ask more than €0,50 extra to increase the possibility of getting a lot of clients.',
          })}
        </p>
        <p>
          <b>
            {intl.formatMessage({
              id: `containers.operations.form.fields.minimum-rate.modal.types-of-rates.important`,
              defaultMessage: 'Important!',
            })}
          </b>
          <br />
          {intl.formatMessage({
            id: `containers.operations.form.fields.minimum-rate.modal.types-of-rates.note`,
            defaultMessage:
              'If you have any travel expenses, please indicate this within the rate. It’s not possible to ask this later on.',
          })}
        </p>
      </Modal.Content>
    </Modal.Wrapper>
  );
};

export default MinimumRateModal;
